import React, { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { formatCurrencyValue } from '@eika/currency-input';

import { useTranslation } from '../../translations';
import { LaanebeloepFormData } from './laanebeloep';
import { nyttLaanebeloep } from './laaneberegning';

const LaaneberegningKredittInfo: FC = () => {
    const { laanebeloep } = useTranslation();
    const { watch } = useFormContext<LaanebeloepFormData>();
    const watchAll = watch();

    return (
        <div>
            <div className="info-box row-gap margin-bottom-small">
                <span className="title">{laanebeloep.infoNyttBoliglaan}</span>
                <span>
                    <span>{`${laanebeloep.infoKredittrammeIDag}: `}</span>
                    <span className="bold">{`${formatCurrencyValue(watchAll.eksisterendeLaanebeloep || 0)} kr`}</span>
                </span>
                <span>
                    <span>{`${laanebeloep.infoNyttLaanebeloep}: `}</span>
                    <span className="bold">{`${formatCurrencyValue(
                        nyttLaanebeloep(watchAll.eksisterendeLaanebeloep || 0, Number(watchAll.soektBeloep || 0)),
                    )} kr`}</span>
                </span>
            </div>
        </div>
    );
};

export default LaaneberegningKredittInfo;
